import { Link } from "react-router-dom";
import { MapPin, User } from "lucide-react";
import { fileUrl } from "../lib/api";

export const ExtraCard = ({ extra, index = 0 }) => {
  const photo = extra.photos?.[0];
  const age =
    extra.playing_age_min != null && extra.playing_age_max != null
      ? `${extra.playing_age_min}–${extra.playing_age_max}`
      : null;
  return (
    <Link
      to={`/${extra.slug}`}
      className="group block fade-up border border-white/10 bg-card hover:-translate-y-1 hover:border-primary/60 transition-[transform,border-color] duration-300"
      style={{ animationDelay: `${Math.min(index, 12) * 60}ms` }}
      data-testid={`extra-card-${extra.slug}`}
    >
      <div className="aspect-[4/5] overflow-hidden bg-muted relative">
        {photo ? (
          <img
            src={fileUrl(photo.path)}
            alt={extra.display_name}
            className="w-full h-full object-cover grayscale-[30%] group-hover:grayscale-0 group-hover:scale-105 transition-[transform,filter] duration-500"
            loading="lazy"
          />
        ) : (
          <div className="w-full h-full grid place-items-center text-white/20">
            <User size={64} />
          </div>
        )}
        {extra.gender && (
          <span className="absolute top-3 left-3 bg-black/70 backdrop-blur px-2 py-1 text-[10px] uppercase tracking-[0.2em]">
            {extra.gender}
          </span>
        )}
      </div>
      <div className="p-4">
        <h3 className="font-display text-xl font-medium truncate">{extra.display_name}</h3>
        <div className="mt-2 text-sm text-white/60 space-y-1">
          <span className="flex items-center gap-1 min-w-0">
            <MapPin size={14} className="text-primary shrink-0" />
            <span className="truncate">{[extra.town, extra.region].filter(Boolean).join(", ") || "Location not set"}</span>
          </span>
          {(age || extra.distance_miles != null) && (
            <span className="flex justify-between">
              <span>{age ? `Age ${age}` : ""}</span>
              {extra.distance_miles != null && <span className="text-primary" data-testid={`extra-distance-${extra.slug}`}>{extra.distance_miles < 1 ? "< 1" : extra.distance_miles} mi</span>}
            </span>
          )}
        </div>
      </div>
    </Link>
  );
};
